import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "crm:flex crm:items-center crm:justify-between" }
const _hoisted_2 = { class: "crm:flex crm:flex-col" }
const _hoisted_3 = { class: "text-black text-uppercase" }
const _hoisted_4 = {
  key: 0,
  class: "my-2"
}
const _hoisted_5 = {
  key: 0,
  class: "my-2"
}

import {inject, ref, watch, reactive} from 'vue'
import BaseControlModal from "../BaseControlModal.vue";
import BaseInputFile from '../BaseInputFile.vue';
import BaseUploadFilesList from "../BaseUploadFilesList.vue";
import NoteDocumenti from "./NoteDocumenti.vue";
import ValidazioneDocumenti from "./ValidazioneDocumenti.vue";
import {usePraticaStore, useChecklistStore} from "../../store/crm.store";
import {trash} from '../../svg/svgs.js'
import {useChecklistInit} from '../../composable/actions/checklist-init'
import {deleteQuestion, postRisposte, executeChecklistValidation, getChecklists} from '../../composable/actions/checklist.repository'

/**
 * @inject {$L_} shortcut per accedere ai metodi di lodash messi a disposizione nel base_instance
 */

export default {
  __name: 'Front',
  props: {
  /**
   * Componente Semplice/Logico da renderizzare
   **/
  atom_component: {
    type: [Array, Object],
    default() {
      return {}
    }
  },
  index: {
    type: Number,
    default: 0
  },
  /**
   * Id del questionario renderizzato
   **/
  questionarioId: {
    type: [String, Number, Object],
    default() {
      return {}
    }
  },
  /**
   * Stato del questionario [front, admin, preview]
   **/
  statoDelQuestionario: {
    type: String,
    default() {
      return {}
    }
  }
},
  setup(__props) {

/**
 * @doc Gestisce e renderizza gli elementi di una checklist
 */
const $L_ = inject('$L_');

/**
 * @inject {$AxiosClient} recupera la libreria per le chiamate ajax
 */
const $AxiosClient = inject('$AxiosClient');

/**
 * @inject {loader}
 */
const loader = inject('loader');

/**
 * @inject {$BaseVueUtils} metodi js prelevati dal framework
 */
const $BaseVueUtils = inject('$BaseVueUtils');


const praticaStore = usePraticaStore();
const checklistStore = useChecklistStore();

const props = __props

const tooltip = ref({
  approva: false,
  rifiuta: false
})

const {fillAndFilterChecklist} = useChecklistInit(checklistStore, praticaStore)

const filesCaricati = ref({})
const additionalData = ref(null)

watch(props, (newValue) => {
  if(newValue.atom_component && newValue.atom_component.value) {
    (newValue.atom_component.value).forEach((item, index) => {
        Object.keys(item).forEach((fileKey) => {
        if(filesCaricati.value[index]) {
            filesCaricati.value[index][fileKey] = (item) ? item[fileKey] : null
          }
        })
    })
    let atom_component_local = $L_.cloneDeep(newValue.atom_component);
    additionalData.value = $L_.merge(atom_component_local, {questionario_id: props.questionarioId, tipo_domanda_id: props.atom_component.id})
  }
}, {deep: true})

/**
 *
 * @param isApprovato
 * @param element
 * @param file
 * @return {Promise<void>}
 */
const gestioneRisposte = async (isApprovato, element, file) => {
  loader.show();
  let documentID = (file.document_id) ? file.document_id : file.documento_id;

  let postRisposte = await executeChecklistValidation($AxiosClient, checklistStore.questionarioIdAttivo, documentID, element.hash, isApprovato, praticaStore.praticaID);
  if (postRisposte && postRisposte.esito === 'ok') {
    let responseQuestionariRichiesti = await getChecklists($AxiosClient, checklistStore.questionarioIdAttivo, praticaStore.praticaID)
    if (responseQuestionariRichiesti && responseQuestionariRichiesti.esito === 'ok') {
      await fillAndFilterChecklist(responseQuestionariRichiesti.questionari[0], responseQuestionariRichiesti.questionari[0].atom_components.elements, props.statoDelQuestionario, false);
    }
  }
  loader.hide();
}

/**
 *
 * @param element
 * @return {Promise<void>}
 */
const immediatePost = async(element) => {
  if (props.statoDelQuestionario !== 'front') return;
  await postRisposte($AxiosClient, props.questionarioId, praticaStore.praticaID, element)
  checklistStore.onControlloDisabilitaPerCtaCompletaValidazione();
}

/**
 *
 * @param files
 */
const settaFileCaricati = (files) => filesCaricati.value = files;

let atom_component_local = $L_.cloneDeep(props.atom_component);
additionalData.value = $L_.merge(atom_component_local, {questionario_id: props.questionarioId, tipo_domanda_id: props.atom_component.id})

/**
 *
 * @param files
 */
const updateVuexAtomComponent = (files) => {
  if(files.length > 0) {
    props.atom_component.value = files.filter(function(x) {
      return x !== undefined;
    });
  }
}

/**
 * Gestisce il toggle della modale di controllo della cancellazione della richiesta di documento
 * @type {UnwrapNestedRefs<{is_show_modal: boolean, message: string}>}
 */
const avvisoCancellazioneRichiestaDocumento = reactive({
  is_show_modal: false,
  message: `la richiesta del documento ${props.atom_component.label}`
})

/**
 *
 * @return {Promise<void>}
 */
async function cancellaRichiestaDocumento() {
  let cancellazione_richiesta = await deleteQuestion($AxiosClient, praticaStore.praticaID, props.questionarioId, props.atom_component.hash)

  if(cancellazione_richiesta && cancellazione_richiesta.esito === 'ok') {
    await checklistStore.onResponseQuestionariRichiesti({init: false, objectToRequest: {
        pratica_id: praticaStore.praticaID,
        questionario_id: props.questionarioId
      }});

    checklistStore.is_show_checklist = false;

    setTimeout(() => {
      checklistStore.is_show_checklist = true;
    }, 100)

    avvisoCancellazioneRichiestaDocumento.is_show_modal = false;
  }
}

/**
 *
 * @return {Promise<void>}
 */
async function reloadChecklistAfterDeleteFile() {
  await checklistStore.onResponseQuestionariRichiesti();
  checklistStore.is_show_checklist = false;

  setTimeout(() => {
    checklistStore.is_show_checklist = true;
  }, 100)
}

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-group position-relative border-b-grey mb-4", {'crm:flex flex-column': __props.statoDelQuestionario === 'readonly'}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(__props.atom_component.label), 1 /* TEXT */),
          (__props.atom_component.formato === 'originale' || __props.atom_component.formato === 'in_copia_conforme_cartacea')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createElementVNode("span", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-exclamation" }, null, -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString('Obbligo di esibizione del documento in '+ (__props.atom_component.formato === 'originale' ? 'originale': 'copia conforme cartacea') + ' al momento dell’atto '), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" cta per la cancellazione della richiesta di documento "),
        (_unref(praticaStore).tipoUtenteConnesso === 'notaio' && __props.atom_component.is_deletable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-icon crm:flex!",
              onClick: _cache[0] || (_cache[0] = $event => (avvisoCancellazioneRichiestaDocumento.is_show_modal = true))
            }, [
              _createVNode(_component_base_icon, {
                icon: _unref(trash),
                stroke: _unref($DesignSystem).design_colors.primary
              }, null, 8 /* PROPS */, ["icon", "stroke"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (__props.atom_component.nota)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("u", { class: "mt-2" }, [
              _createElementVNode("strong", null, "Istruzioni: ")
            ], -1 /* CACHED */)),
            _createElementVNode("span", null, _toDisplayString(__props.atom_component.nota.value), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(BaseInputFile, {
        "extension-accepted": _unref(praticaStore).documentExtensionAccepted,
        value: __props.atom_component.value,
        "onUpdate:value": updateVuexAtomComponent,
        "validate-to": __props.atom_component,
        name: __props.atom_component.name,
        "field-id": __props.atom_component.id,
        options: __props.atom_component.options ? __props.atom_component.options : null,
        "fw-input-type": __props.atom_component.type !== 'component' ? __props.atom_component.type : null,
        hash: __props.atom_component.hash,
        label: null,
        state: (__props.atom_component.enabled === 'false') ? 'readonly'  : __props.statoDelQuestionario,
        helperNote: __props.statoDelQuestionario !== 'readonly' ? __props.atom_component.note : null,
        "http-options": {remove: {module: 'Questionario', action: 'deleteQuestionarioFile'}},
        "additional-data": additionalData.value,
        "immediate-upload": true,
        onTriggerImmediatePost: immediatePost,
        onFileCaricati: settaFileCaricati,
        onAfterDeleteFile: reloadChecklistAfterDeleteFile
      }, {
        default: _withCtx(({filesUploaded, filesRejected, cancellaFile, downloadFile, progressSize}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesRejected, (file, index) => {
            return (_openBlock(), _createBlock(BaseUploadFilesList, {
              key: `rejected-${index}`,
              state: (__props.atom_component.enabled === 'false') ? 'readonly'  : __props.statoDelQuestionario,
              arrayIndex: index,
              file: file,
              onRemoveFileClick: cancellaFile,
              onDownloadFileClick: downloadFile
            }, null, 8 /* PROPS */, ["state", "arrayIndex", "file", "onRemoveFileClick", "onDownloadFileClick"]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesUploaded, (file, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              file
                ? (_openBlock(), _createBlock(BaseUploadFilesList, {
                    key: 0,
                    file: file,
                    state: (file.is_accettato === 0) ? 'disabled' : (__props.atom_component.enabled === 'false') ? 'readonly'  : __props.statoDelQuestionario,
                    arrayIndex: index,
                    "progress-size": progressSize[file.nome_file],
                    onRemoveFileClick: cancellaFile,
                    onDownloadFileClick: downloadFile
                  }, {
                    actions: _withCtx(() => [
                      _createVNode(ValidazioneDocumenti, {
                        class: "col-sm-5",
                        "stato-del-questionario": __props.statoDelQuestionario,
                        risposta: file,
                        domanda: __props.atom_component,
                        onGestioneRisposte: gestioneRisposte
                      }, null, 8 /* PROPS */, ["stato-del-questionario", "risposta", "domanda"])
                    ]),
                    additionalElement: _withCtx(() => [
                      _createVNode(NoteDocumenti, {
                        file: file,
                        "file-index": index,
                        element: __props.atom_component
                      }, null, 8 /* PROPS */, ["file", "file-index", "element"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["file", "state", "arrayIndex", "progress-size", "onRemoveFileClick", "onDownloadFileClick"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["extension-accepted", "value", "validate-to", "name", "field-id", "options", "fw-input-type", "hash", "state", "helperNote", "additional-data"])
    ], 2 /* CLASS */),
    (avvisoCancellazioneRichiestaDocumento.is_show_modal)
      ? (_openBlock(), _createBlock(BaseControlModal, {
          key: 0,
          message: avvisoCancellazioneRichiestaDocumento.message,
          "onConfirm:control": cancellaRichiestaDocumento,
          "onClose:control": _cache[1] || (_cache[1] = $event => (avvisoCancellazioneRichiestaDocumento.is_show_modal = false))
        }, null, 8 /* PROPS */, ["message"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}